module.exports = __webpack_public_path__ + "img/aqfh-img-32.005f67e2.png";